import React from "react";
import PropTypes from "prop-types";
import { Link as GatsbyLink } from "gatsby";

import { Link as StyledLink } from "../../style/Link";

const Link = props => {
  if (
    props.href &&
    (props.href.includes("https://") ||
      props.href.includes("http://") ||
      props.href.includes("mailto:") ||
      props.href.includes("tel:") ||
      props.href.includes(".pdf") ||
      props.href[0] === "#")
  ) {
    return (
      <StyledLink as="a" {...props} href={props.href} rel="noopener noreferrer">
        {props.children}
      </StyledLink>
    );
  }
  return (
    <StyledLink as={GatsbyLink} {...props} to={props.href}>
      {props.children}
    </StyledLink>
  );
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
};

export default Link;
